import { placements } from './getPlacement';
import { Placement } from './types';

interface Params {
  /** Popper placement prop */
  placement: Placement;
  /**
   * offsetSkidding: the cross-axis pixel distance that the popup should be offset from targetElement
   *
   * @default 0
   */
  offsetSkidding: number;
  /**
   * offsetDistance: the main-axis pixel distance that the popup should be offset from targetElement
   *
   * @default 0
   */
  offsetDistance: number;
  /**
   * offsetX: the x axis pixel distance that the popup should be offset from targetElement
   *
   * @default 0
   * @deprecated Please use offsetSkidding instead
   */
  offsetX: number;
  /**
   * offsetY: the y axis pixel distance that the popup should be offset from targetElement
   *
   * @default 0
   * @deprecated Please use offsetDistance instead
   */
  offsetY: number;
}

/** Translate offset props to Popper skidding and distance. Also takes into account deprecated props for backward compatibility */
export const getOffset = ({
  placement,
  offsetSkidding,
  offsetDistance,
  offsetX,
  offsetY
}: Params): [number, number] => {
  // Simply return if
  // 1. latest props are used OR
  // 2. deprecated props are not used
  if (
    offsetSkidding !== 0 ||
    offsetDistance !== 0 ||
    (offsetX === 0 && offsetY === 0)
  ) {
    return [offsetSkidding, offsetDistance];
  }

  let skidding;
  let distance;

  switch (placement) {
    case 'left':
    case placements.LEFT:
    case placements.LEFT_TOP:
    case placements.LEFT_BOTTOM:
    case 'right':
    case placements.RIGHT:
    case placements.RIGHT_TOP:
    case placements.RIGHT_BOTTOM:
      skidding = -offsetY;
      distance = offsetX;
      break;
    case 'top':
    case placements.TOP:
    case placements.TOP_LEFT:
    case placements.TOP_RIGHT:
    case 'bottom':
    case placements.BOTTOM:
    case placements.BOTTOM_LEFT:
    case placements.BOTTOM_RIGHT:
    default:
      skidding = offsetX;
      distance = -offsetY;
      break;
  }

  return [skidding, distance];
};
